import { useQuery } from 'react-query'
import { useSearchParams } from 'react-router-dom'
import { getErrorString } from 'src/utils'
import { getTokenForCode } from './api'
import { savedBackendRegion } from 'src/storage'
import { toast } from 'sonner'

const keys = {
  all: ['AUTH'] as const,
  codes: () => [...keys.all, 'CODES'] as const,
  code: (code?: string) => [...keys.codes(), code] as const,
}

export function useGetTokenForCode() {
  const [searchParams, setSearchParams] = useSearchParams()
  const code = searchParams.get('code')

  return useQuery(
    keys.code(code as string),
    () =>
      getTokenForCode(
        code as string,
        savedBackendRegion.get() || 'eu-central-1',
      ),
    {
      retry: 0,
      staleTime: Infinity,
      enabled: !!code,
      onError: (error) => {
        toast.error(
          `An error occurred while fetching tokens: ${getErrorString(error)}`,
        )
      },
      onSettled: () => {
        searchParams.delete('code')
        setSearchParams(searchParams, { replace: true })
      },
    },
  )
}
